import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Settlement/rightAngle.png'
import _imports_1 from '@/assets/Settlement/btmAngle.png'
import _imports_2 from '@/assets/Settlement/jilu.png'


const _withScopeId = n => (_pushScopeId("data-v-5ccaebb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Settlement" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划说明", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "rightAngle",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "headContent" }
const _hoisted_7 = { class: "classTitle" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "subjectTitle" }
const _hoisted_10 = {
  class: "btmAngle",
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = { class: "record" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"9px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"9px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "cardContent" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "subjectBox" }
const _hoisted_18 = { class: "subjectInfo" }
const _hoisted_19 = { class: "classTitle" }
const _hoisted_20 = { class: "price" }
const _hoisted_21 = { class: "footBtm" }
const _hoisted_22 = { class: "foottext" }
const _hoisted_23 = { class: "submitMoney" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yingfu" }, " 应付金额 ￥ ", -1))
const _hoisted_25 = { class: "hasSelect" }
const _hoisted_26 = { class: "money" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_CellGroup = _resolveComponent("CellGroup")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CheckboxGroup = _resolveComponent("CheckboxGroup")!
  const _component_Picker = _resolveComponent("Picker")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_Area = _resolveComponent("Area")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentClass.info['remark'])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plan",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPlan && _ctx.showPlan(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "logout",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, " 退出 "),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentClass.info.feePlanName), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "title",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.classList.length>1?_ctx.showSubject=true:''))
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.currentClass.class.className), 1),
            _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
              [_vShow, _ctx.classList.length>1]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: "recordText",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toRecord && _ctx.toRecord(...args)))
            }, " 缴费记录 ")
          ])
        ]),
        _createVNode(_component_Form, { ref: "form" }, {
          default: _withCtx(() => [
            _createVNode(_component_CellGroup, { inset: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentClass.info.feePlanUserFormVoList, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.fieldId != 5 && item.fieldId != 7 && item.fieldShow==1)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 0,
                          modelValue: item.fieldValue1,
                          "onUpdate:modelValue": ($event: any) => ((item.fieldValue1) = $event),
                          class: _normalizeClass({'required':item.fieldRequired==1}),
                          label: item.fieldName,
                          "label-width": 85,
                          maxlength: "30",
                          name: "name",
                          placeholder: '请输入'+item.fieldName,
                          "input-align": "right"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "label", "placeholder"]))
                      : _createCommentVNode("", true),
                    (item.fieldId == 5 && item.fieldShow==1)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 1,
                          modelValue: item.fieldValue1,
                          "onUpdate:modelValue": ($event: any) => ((item.fieldValue1) = $event),
                          label: item.fieldName,
                          "label-width": 85,
                          class: _normalizeClass({'required':item.fieldRequired==1}),
                          name: "school",
                          readonly: "",
                          placeholder: '请输入'+item.fieldName,
                          "input-align": "right",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSchool = true))
                        }, {
                          button: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "label", "class", "placeholder"]))
                      : _createCommentVNode("", true),
                    (item.fieldId == 7 && item.fieldShow==1)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 2,
                          modelValue: _ctx.area,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.area) = $event)),
                          label: item.fieldName,
                          class: _normalizeClass({'required':item.fieldRequired==1}),
                          "label-width": 85,
                          name: "area",
                          placeholder: '请输入'+item.fieldName,
                          readonly: "",
                          "input-align": "right",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showArea = true))
                        }, {
                          button: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "label", "class", "placeholder"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_CheckboxGroup, {
          modelValue: _ctx.checked,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checked) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentClass.info.itemVoList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "cardItem"
              }, [
                _withDirectives(_createElementVNode("img", {
                  class: "yigoumai",
                  src: item.purchaseStatus==1?require('@/assets/Settlement/shuiyin-yigoumai.png'):require('@/assets/Settlement/shuiyin-yidengji.png'),
                  alt: ""
                }, null, 8, _hoisted_16), [
                  [_vShow, item.purchaseStatus&&item.purchaseStatus != 0]
                ]),
                ((!item.purchaseStatus||item.purchaseStatus == 0)&&_ctx.computedSubmit().msg!='计划已结束')
                  ? (_openBlock(), _createBlock(_component_Checkbox, {
                      key: 0,
                      style: {"overflow":"none","margin-top":"3px","margin-right":"15px"},
                      name: item.id,
                      shape: "square"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.itemName), 1),
                    _withDirectives(_createElementVNode("div", { class: "time" }, " 考试时间 " + _toDisplayString(item.examTime?(item.examTime):'无'), 513), [
                      [_vShow, _ctx.currentClass.info.feeType==1]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, " ￥" + _toDisplayString(item.itemPrice/100), 1)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, " 已选择 " + _toDisplayString(_ctx.checked.length) + "项 ", 1)
          ]),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.computePrice / 100), 1)
        ]),
        _createElementVNode("div", {
          "native-type": "submit",
          class: _normalizeClass([{'disable':_ctx.computedSubmit().msg=='计划已结束'}, "toSubmit"]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.computedSubmit().msg=='计划已结束'?null:_ctx.submit()))
        }, _toDisplayString(_ctx.submitText), 3)
      ])
    ]),
    _createVNode(_component_Popup, {
      show: _ctx.showSchool,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showSchool) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Picker, {
          columns: _ctx.schoolExamAreaOptions,
          "columns-field-names": _ctx.currentClass.customFieldName,
          onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSchool = false)),
          onConfirm: _ctx.onSchoolConfirm
        }, null, 8, ["columns", "columns-field-names", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_Popup, {
      show: _ctx.showArea,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showArea) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Area, {
          "area-list": _ctx.areaList,
          "columns-num": "2",
          onConfirm: _ctx.onConfirm,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showArea = false))
        }, null, 8, ["area-list", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_Popup, {
      show: _ctx.showSubject,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showSubject) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Picker, {
          columns: _ctx.classList,
          "columns-field-names": _ctx.currentClass.subjectFieldName,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showSubject = false)),
          onConfirm: _ctx.onSubjectConfirm
        }, null, 8, ["columns", "columns-field-names", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}